import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	totalCards: {
		id: 'backlog.card-list.divider.divider-statistics.total-cards',
		defaultMessage: '{cardAmount} {cardAmount, plural, one {issue} other {issues}}',
		description: 'total cards amount label',
	},
	remainingLabel: {
		id: 'backlog.card-list.divider.divider-statistics.remaining-label',
		defaultMessage: 'Remaining: <strong> {estimate}</strong>',
		description: 'remaining estimate label',
	},
	estimateLabel: {
		id: 'backlog.card-list.divider.divider-statistics.estimate-label',
		defaultMessage: 'Estimate: <strong> {estimate}</strong>',
		description: 'estimate label',
	},
	filteredAmountCards: {
		id: 'backlog.card-list.divider.divider-statistics.filtered-amount-cards',
		defaultMessage:
			'{filteredIssues} of {cardAmount} {cardAmount, plural, one {issue} other {issues}} visible',
		description: 'filtered cards amount of total cards amount label',
	},
	filteredRemainingLabel: {
		id: 'backlog.card-list.divider.divider-statistics.filtered-remaining-label',
		defaultMessage:
			'Remaining: <strong>{filteredEstimate}</strong> of <strong> {estimate}</strong>',
		description: 'filtered remaining estimate of total remaining estimate label',
	},
	filteredEstimateLabel: {
		id: 'backlog.card-list.divider.divider-statistics.filtered-estimate-label',
		defaultMessage: 'Estimate: <strong>{filteredEstimate}</strong> of <strong> {estimate}</strong>',
		description: 'filtered estimate of total estimate label',
	},
});
